module.exports = __webpack_public_path__ + "img/financial.aaa2740f.svg";